import React, { FC } from 'react';
import { SectionWrapper } from '../../SectionWrapper';
import { useTranslation } from 'react-i18next';
import { FormInput, IFormInputProps } from '../../merchants/FormInput';
import {
  ACCOUNT_INFO_ADMIN_INPUTS,
  ACCOUNT_INFO_INTEGRATION_PARTNER_INPUTS,
  ACCOUNT_INFO_PARTNER_INPUTS,
} from '../../../constants/new-application/quick-application/account-information-inputs';
import { useMerchants } from '../../../store/merchnts/merchants-context';
import { useIdentity } from '../../../store/identyti/identity-context';
import { useParams } from 'react-router-dom';
import { checkIfValidUUID } from '../../../layout/core';
import { IAuthState } from '../../../redux/AuthRedux';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../../setup';
import { checkRoles, CLAIMS } from '../../../utils/roles-helper';
import { getTitle } from '../../form/FakeInputHelper';
import clsx from 'clsx';
import { WhisperComponent } from '../../developers/page-components/WhisperComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

interface Props {
  formik: any;
}
export const AccountInformation: FC<Props> = (props) => {
  const { formik } = props;

  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const applicationId = checkIfValidUUID(id) ? id : undefined;
  const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);

  const { identityState: { accountManagerList }} = useIdentity();
  const { merchantState } = useMerchants();
  const {
    merchantsLists,
    integrationPartnersListSelector,
    whitelabelPartnersListSelector,
    salesAgencyListSelector,
      crmId
  } = merchantState;

  const getInputs = (): IFormInputProps[] => {
    switch (true) {
      case checkRoles(authUser, CLAIMS.SUPER_ADMIN):
        return ACCOUNT_INFO_ADMIN_INPUTS({
          t,
          partnerList: whitelabelPartnersListSelector,
          integrationPartnerList: integrationPartnersListSelector,
          integrationTierList: merchantsLists?.integrationTiers,
          accountManagerList,
          salesAgencyListSelector,
          applicationId,
            crmId
        });
      case checkRoles(authUser, CLAIMS.PARTNER_ADMIN):
        return ACCOUNT_INFO_PARTNER_INPUTS({
          t,
          partnerList: whitelabelPartnersListSelector,
          integrationPartnerList: integrationPartnersListSelector,
          integrationTierList: merchantsLists?.integrationTiers,
          // accountManagerList,
          salesAgencyListSelector,
          applicationId
        });
      case checkRoles(authUser, CLAIMS.INTEGRATION_PARTNER_ADMIN):
        return ACCOUNT_INFO_INTEGRATION_PARTNER_INPUTS({
          t,
          partnerList: whitelabelPartnersListSelector,
          integrationPartnerList: integrationPartnersListSelector,
          integrationTierList: merchantsLists?.integrationTiers,
          accountManagerList,
          salesAgencyListSelector,
          applicationId
        });
    }
  };

  // @ts-ignore
  return (
    <SectionWrapper
      title={t('NEW_APPLICATION.ACCOUNT_INFORMATION')}
      pageLoading={false}
      isCardBody
      sectionAdditionalClass="mb-10"
    >
      <div className="row">
        {
          getInputs().map(item => {
            return (
                <FormInput
                    {...item}
                    formik={formik}
                    isEditMode={true}
                    key={item.key}
                />
            );
          })
        }

        {/*TODO make this as a component, duplicate with NewApplicationAccountInformation*/}
        <div className="col-6 col-sm-4 col-md-3 fv-row mb-5 d-flex align-items-end">
          <div className="form-check fw-bold col-md-12  d-flex align-items-center"
               style={{ minHeight: '37px', height: '100%', marginBottom: 0 }}>
            <input
                className="form-check-input flex-shrink-0"
                type="checkbox"
                value=""
                id="contractAlreadySigned"
                checked={formik.values.contractAlreadySigned}
                onChange={(e): void => {
                  formik.setFieldValue('contractAlreadySigned', e.target.checked);
                }}
                style={{
                  width: 23,
                  height: 23
                }}
            />

            <div className={clsx('d-flex align-items-center mb-1')} style={{ paddingLeft: '6px' }}>
              <label className="form-check-label">
                {t('NEW_APPLICATION.CONTRACT_ALREADY_SIGNED')}
                <span className="cursor-pointer ms-1">
                  <WhisperComponent
                      isTooltip
                      whisperText={t('NEW_APPLICATION.CONTRACT_ALREADY_SIGNED_TOOLTIP')}
                      mainText={<FontAwesomeIcon icon={faQuestionCircle} width={12} />}
                  />
                </span>
              </label>

            </div>
          </div>
        </div>

        {/*TODO make this as a component, duplicate with NewApplicationAccountInformation*/}
        <div className="col-6 col-sm-4 col-md-3 fv-row mb-5 d-flex align-items-end">
          <div className="form-check fw-bold col-md-12  d-flex align-items-center"
               style={{ minHeight: '37px', height: '100%', marginBottom: 0 }}>
            <input
                className="form-check-input flex-shrink-0"
                type="checkbox"
                value=""
                id="integrationPartnerParticipateSale"
                checked={formik.values.integrationPartnerParticipateSale}
                onChange={(e): void => {
                  formik.setFieldValue('integrationPartnerParticipateSale', e.target.checked);
                }}
                style={{
                  width: 23,
                  height: 23
                }}
            />

            <div className={clsx('d-flex align-items-center mb-1')} style={{ paddingLeft: '6px' }}>
              <label className="form-check-label">
                {t('NEW_APPLICATION.INTEGRATION_PARTNER_PARTICIPATE_SALE')}
                {/*<span className="cursor-pointer ms-1">*/}
                {/*  <WhisperComponent*/}
                {/*      isTooltip*/}
                {/*      whisperText={t('NEW_APPLICATION.CONTRACT_ALREADY_SIGNED_TOOLTIP')}*/}
                {/*      mainText={<FontAwesomeIcon icon={faQuestionCircle} width={12} />}*/}
                {/*  />*/}
                {/*</span>*/}
              </label>

            </div>
          </div>
        </div>

        {/*<div className={clsx("col-6 col-sm-4 col-md-3 fv-row input-container mb-5")}>*/}
        {/*  <div>*/}
        {/*    <label className="form-check-label" htmlFor="contractAlreadySigned">*/}
        {/*      {t("NEW_APPLICATION.CONTRACT_ALREADY_SIGNED")}*/}
        {/*    </label>*/}
        {/*  </div>*/}
        {/*  <div className="p-0 pt-4">*/}
        {/*    <input*/}
        {/*        className="form-check-input"*/}
        {/*        type="checkbox"*/}
        {/*        value=""*/}
        {/*        id="contractAlreadySigned"*/}
        {/*        checked={formik.values.contractAlreadySigned}*/}
        {/*        onChange={(e): void => {*/}
        {/*          formik.setFieldValue('contractAlreadySigned', e.target.checked);*/}
        {/*        }}*/}
        {/*    />*/}
        {/*  </div>*/}


      </div>
    </SectionWrapper>
  );
};
